import { render, staticRenderFns } from "./printBoleto.vue?vue&type=template&id=31ea16f0&"
import script from "./printBoleto.vue?vue&type=script&lang=js&"
export * from "./printBoleto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "printBoleto.vue"
export default component.exports